<template>
  <div>
    <div class="heading">Promo</div>

    <div class="filter">
      <div class="row">
        <div class="small-4 column end">
          <div class="search-box">
            <label class="field-label">Search</label>
            <div class="search">
              <div class="search-input-box">
                <input type="text" v-model="searchInput" ref="search" :disabled="loading"
                  v-on:keypress.enter="search" v-on:blur="blurSearch" />
                <transition name="slide-left">
                  <i class="far fa-times-circle fa-lg" @click="clearSearch"
                    v-if="searchInput.length > 0"></i>
                </transition>
              </div>
              <button :class="{'button xsmall success':true, 'disabled':loading}"
                @click="search">
                <i class="fas fa-search fa-lg"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="small-2 column add-promo">
          <div class="button cta success" @click="showAdd">Add Promo</div>
        </div>
      </div>
    </div>

    <promo-list :isMobile="isMobile"></promo-list>

    <div class="fix-footer">
      <div class="row">
        <div class="small-3 columns per-page">
          <span>Displaying</span>
          <select v-model="perPage" :disabled="loading">
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span>per page</span>
        </div>

        <div class="small-6 columns page-data">
          <span v-show="promo.length > 0">
            Displaying
            <b>{{ pageData.start }}</b> - <b>{{ pageData.end }}</b> of
            <b>{{ pageData.max }}</b>
          </span>
        </div>

        <div class="small-3 columns pagination">
          <span>Page</span>
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev">
            <i class="fas fa-chevron-left"></i>
          </span>
          <select v-model="currentPage" :disabled="loading">
            <option v-for="i in totalPage" :value="i">{{i}}</option>
          </select>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>
      </div>
    </div>

    <promo-add @save="getPromo" :isMobile="isMobile"></promo-add>
  </div>
</template>

<script>
import promoList from './PromoList'
import promoAdd from './PromoAdd'
import ApiPromo from '@/modules/api/promo'

export default {
  name: 'promo',
  components: { promoList, promoAdd },
  data () {
    return {
      searchInput: '',
      isMobile: false
    }
  },
  computed: {
    promo () { return this.$store.state.promo.list },
    loading () { return this.$store.state.promo.loading },
    perPage: {
      get: function () { return this.$store.state.promo.perPage },
      set: function (value) {
        this.$store.commit('promo/setPerPage', parseInt(value))
        this.$store.commit('promo/setCurrentPage', 1)
        this.getPromo()
      }
    },
    pageData () {
      let tableData = this.$store.state.promo
      let start = (tableData.currentPage * tableData.perPage) - (tableData.perPage - 1)
      let end = tableData.currentPage * tableData.perPage
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      }
    },
    currentPage: {
      get: function () { return this.$store.state.promo.currentPage },
      set: function (value) {
        this.$store.commit('promo/setCurrentPage', parseInt(value))
        this.getPromo()
      }
    },
    isLastPage () {
      let promo = this.$store.state.promo
      return (promo.currentPage * promo.perPage) >= promo.maxList
    },
    totalPage () {
      let promo = this.$store.state.promo
      return Math.ceil(promo.maxList / promo.perPage)
    }
  },
  methods: {
    getPromo () {
      let self = this

      self.$store.commit('promo/setLoading', true)

      ApiPromo.getList(self, {isNext: true}, function (res) {
        self.$store.commit('promo/setLoading', false)
      })
    },
    clearSearch () {
      this.searchInput = ''
      this.$store.commit('promo/setSearch', '')
      this.$store.commit('promo/setCurrentPage', 1)
      this.getPromo()
    },
    blurSearch () {
      let self = this
      if (self.$store.state.promo.search === self.searchInput.trim()) { return }

      self.blurDelay = setTimeout(function () {
        self.search()
      }, 500)
    },
    search () {
      this.$store.commit('promo/setCurrentPage', 1)
      this.$store.commit('promo/setSearch', this.searchInput)
      this.getPromo()
    },
    prev () {
      if (this.currentPage === 1) { return }
      this.$store.commit('promo/setCurrentPage', this.$store.state.promo.currentPage - 1)
      this.getPromo()
    },
    next () {
      if (this.isLastPage) { return }
      this.$store.commit('promo/setCurrentPage', this.$store.state.promo.currentPage + 1)
      this.getPromo()
    },
    showAdd () { this.$store.commit('promo/setShowAdd', true) },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    }
  },
  watch: {
    // brandFormShow: function (value) {
    // },
  },
  mounted () {
    this.getPromo()
    this.setScreenSize()
  }
}
</script>

<style lang="scss" scoped>
.heading{
  margin-left: 50px;
  padding-left: 10px;
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  line-height: 50px;
  color: #3F2975;
  font-size: 21px;
  font-weight: 600;
  text-transform: uppercase;
}

.filter{
  border-bottom:1px solid #bbb;
  background: #fcfcfc;
  margin-bottom: 10px;
  border-radius: 2px;

  .row{ max-width: 100%; }
}
.field-label{
  font-size: 13px;
  color: #999;
  line-height: 1;
  display: block;
  margin-bottom: 4px;
}
.search-box{
  display: inline-block;
  padding: 10px 0 10px 15px;
  position: relative;
  width: 100%;

  .error-msg{
    position: absolute;
    bottom: 0;
    left: 0;
    width: calc(100% - 15px);
    padding: 2px 5px;
    font-size: 12px;
    text-align: center;
    margin-left: 15px;
    background: #ff6115;
    color: #fff;
    transform-origin: bottom center;
  }
}
.search{
  box-sizing: border-box;
  display: flex;
  width: 100%;

  .search-input-box{
    width: 100%;
    position: relative;

    input{
      display: inline-block;
      vertical-align: middle;
      margin-top: 0;
      border-radius: 5px 0 0 5px;
      padding-right: 30px;

      &.has-error{ border-color:#f33a27; }
    }
    i{
      position: absolute;
      top: 0;
      right: 5px;
      color: #d92626;
      cursor: pointer;
      line-height: 46px;
    }
  }
  button{
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    border-radius: 0 5px 5px 0;
    padding: 0 20px;
  }
}

.add-promo{
  text-align: right;
  padding: 20px 15px 0;
}

.fix-footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background: #eaeaea;
  border-top: 1px solid #aaa;
  font-size: 13px;
  color: #555;

  .row{ max-width: 100%; }
  select{
    max-width: 100px;
    height: 30px;
    padding: 5px;
  }
  .per-page{
    display: flex;
    line-height: 30px;
    padding: 10px 0;

    span{
      display: inline-block;
      margin: 0 10px;
    }
  }
  .page-data{
    text-align: center;
    line-height: 30px;
    padding: 10px 0;
  }
  .pagination{
    text-align: right;
    padding: 10px 10px;

    span{
      display: inline-block;
      margin-right: 5px;
    }
    select{
      height: 30px;
      vertical-align: middle;
    }
    .prevNext{
      margin: 0 2px;
      padding: 0 8px;
      border: 1px solid #bbb;
      background: #fff;
      cursor: pointer;
      vertical-align: middle;
      height: 30px;

      i{ line-height:28px; }
      &.disabled{
        opacity: .4;
        cursor: default;
      }
    }
  }
}

@media only screen and (max-width: 430px) {
  .filter {
    .row {
      width: 100%;
      .search-box {
        padding: 10px 15px;
      }
      .add-promo {
        padding-top: 0;
        padding-bottom: 10px;

        .button {
          width: 100%;
        }
      }
      .small-4, .small-2 {
        width: 100%;
      }
    }
  }
  .fix-footer {
    .row {
      display: flex;
    }
    .per-page {
      width: auto;
      select {
        width: 55px;
      }
      span:nth-child(3) {
        display: none;
      }
    }
    .page-data {
      display: none;
    }
    .pagination {
      display: flex;
      align-items: center;
      margin-right: 15%;

      select {
        width: 55px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Promo/index.vue